module.exports = __webpack_public_path__ + "img/suo-lite.553bec5f.png";